module.exports = __webpack_public_path__ + "img/invisible-signin.b8d74c35.svg";